( function( $ ) {
  var wasEventTriggeredByKeyboard = function (e) {
    return (
      (e.pageX === 0 && e.pageY === 0) // chrome
      || (e.timeStamp === 0)              // firefox
    );
  };

  var wasEventTriggeredByKeyboard = function (e) {
    return (
      (e.pageX === 0 && e.pageY === 0) // chrome
      || (e.timeStamp === 0)              // firefox
    );
  };

  $('li', '#main-navigation').has('ul').each(function () {

    $(this).find('>a').wrap('<span class="wrap-for-expand"></span>');
    $(this).find('>span').prepend(
      $('<a/>', {
        'class': 'expand ' + (($(this).hasClass('current-menu-parent') || $(this).hasClass('current-menu-ancestor') || $(this).hasClass('current-menu-item')) ? 'close' : ''),
        'href': '#',
        'html': '<span class="icon">'
      }).on('click.expandable-mega-menu', function (e) {
        e.preventDefault();
        $(this).toggleClass('close').parent('span').siblings('ul').slideToggle();
        // close child menus
        if (!$(this).hasClass('close')) {
          $(this).parent('span').siblings('ul').find('.expand.close').removeClass('close').parent('span').siblings('ul').slideUp();
        }
        if (wasEventTriggeredByKeyboard(e) === false) {
          // blur so we wont get stuck on focus style
          $(this).trigger('blur');
        }
      })
    );
  });

  $('.toggle-navigation[data-target="#main-navigation"]').on('click.expandable-mega-menu', function (e) {
    // close all menus when hiding navigation
    if (!$(this).hasClass('collapsed')) {
      // trigger toggle on opened first level menus
      //$('#main-navigation ul:first-child > li > span.wrap-for-expand a.expand.close').trigger('click');

      // reset menu state to original
      $('#main-navigation ul > li ul').removeAttr('style');
      $('#main-navigation ul > li a.expand.close').removeClass('close');
      $('#main-navigation ul > li ul:visible').prev('.wrap-for-expand').find('a.expand').addClass('close');
    }
    if (wasEventTriggeredByKeyboard(e) === false) {
      // blur so we wont get stuck on focus style
      $(this).trigger('blur');
    }
  });

  $('.toggle-languages[data-target="#languages"]').on('click.expandable-mega-menu', function (e) {
    if (wasEventTriggeredByKeyboard(e) === false) {
      // blur so we wont get stuck on focus style
      $(this).trigger('blur');
    }
  });
} )( jQuery );
